<div class="stepper-wrapper">
<div class="step-number6">
    <ng-container *ngFor="let step of steps; let i = index">
      <div class="stepbar-text-number" [ngClass]="{
        'active': step.number === currentStep,
        'completed': step.number < currentStep
      }">
        <div class="div">
          {{ step.number === currentStep ? (step.label | translate) : step.number }}
        </div>
      </div>
  
      <div class="line" *ngIf="i < steps.length - 1">
        <img 
          class="line-icon" 
          alt="" 
          [src]="
            step.number < currentStep
              ? '../assets/others/stepper-line-active.svg'
              : '../assets/others/stepper-line.svg'
          " />
      </div>
    </ng-container>
  </div>
</div>
  